var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 10.3337C9.28868 10.3337 10.3334 9.28899 10.3334 8.00033C10.3334 6.71166 9.28868 5.66699 8.00002 5.66699C6.71136 5.66699 5.66669 6.71166 5.66669 8.00033C5.66669 9.28899 6.71136 10.3337 8.00002 10.3337Z",
    stroke: "#197A56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4586 7.28953C13.7174 7.60373 13.8468 7.7608 13.8468 8C13.8468 8.2392 13.7174 8.39627 13.4586 8.71047C12.5119 9.85993 10.4238 12 7.99998 12C5.57616 12 3.48802 9.85993 2.5413 8.71047C2.28252 8.39627 2.15314 8.2392 2.15314 8C2.15314 7.7608 2.28252 7.60373 2.5413 7.28953C3.48802 6.14009 5.57616 4 7.99998 4C10.4238 4 12.5119 6.14009 13.4586 7.28953Z",
    stroke: "#197A56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.15aed6f3afd2db098274c07afb8efef3.svg";
export { ForwardRef as ReactComponent };